/** Refactor routing ok  */
import { RouteName } from "../RouteNames";

export const cabinetsRoutes = {
  name: RouteName.CabinetsRoot,
  path: "cabinets",
  redirect: () => ({ name: RouteName.Cabinets }),
  children: [
    {
      name: RouteName.Cabinets,
      path: "",
      component: () =>
        import("@follaw-fr/views/side_menu_views/CabinetsView.vue"),
    },
    {
      name: RouteName.CabinetsZoom,
      path: ":_id",
      component: () =>
        import("@follaw-fr/views/side_menu_views/CabinetsZoomView.vue"),
    },
  ],
};
